import {
    HomeOutlined, FileTextOutlined, ProfileOutlined, InstagramOutlined,
    SettingOutlined, ContainerOutlined, FieldTimeOutlined, BlockOutlined,
    TeamOutlined
} from '@ant-design/icons';
// var serverIP = "pd.xidigo.com";
// var serverIP = "umusic.geigong.online";
let serverIP = window.location.host.split(':')[0];
if (process.env.NODE_ENV === 'development') {
    serverIP = "127.0.0.1";
    // serverIP = "192.168.3.5";
    // serverIP = "umusic.xidigo.com";
    serverIP = "umusic.feigong.online";
}
var serverPORT = "10002";
var protocol = window.location.protocol;
if (window.location.protocol == 'https:') {
    serverIP = window.location.host;
    serverPORT = "443";
}

console.log(window.location.host);
console.log(serverIP);
console.log(protocol);

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    title: 'U-Music',
    version: "1.0.0",
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        dev: protocol + '//' + serverIP + ':' + serverPORT + '/api/v1/',
        pro: protocol + '//' + serverIP + ':' + serverPORT + '/api/v1/',
        // dev: 'https://' + serverIP + '/api/v1/',
        // pro: 'https://' + serverIP + '/api/v1/',
    },
    templateUrl: {
        dev: 'http://' + serverIP + ':' + serverPORT + '/',
        pro: 'http://' + serverIP + ':' + serverPORT + '/',
    },
    /**
     * @description 默认表格显示的记录条数
     */
    pageSize: 8,
    mapZoomScale: 15,
    maxPicCount: 10,
    // baseImageUrl: {
    //     dev: 'http://' + serverIP + ':' + serverPORT + '/file/',
    //     pro: 'http://' + serverIP + ':' + serverPORT + '/file/',
    // },
    baseFileUrl: {
        dev: protocol + '//' + serverIP + ':' + serverPORT + '/file/',
        pro: protocol + '//' + serverIP + ':' + serverPORT + '/file/',
    },
    baseLogFileUrl: {
        dev: protocol == "https" ? `${protocol}//${serverIP}/log/` : protocol + '//' + serverIP + ':' + serverPORT + '/log/',
        pro: protocol == "https" ? `${protocol}//${serverIP}/log/` : protocol + '//' + serverIP + ':' + serverPORT + '/log/',
    },
    baseMediaUrl: {
        dev: protocol + '//' + serverIP + ':' + serverPORT + '/api/vi/media/',
        pro: protocol + '//' + serverIP + ':' + serverPORT + '/api/vi/media/',
    },
    websocketUri: {
        dev: serverIP + ':' + serverPORT,
        pro: window.location.host,
    },
    websocketPath: {
        dev: '',
        pro: '',
    },
    menus: [
        { name: "首页", key: "/sys/home", icon: <HomeOutlined /> },
        { name: "活动", key: "/sys/banner", icon: <BlockOutlined /> },
        { name: "达人秀", key: "/sys/show", icon: <InstagramOutlined /> },
        { name: "学生", key: "/sys/student", icon: <TeamOutlined /> },
        { name: "教师", key: "/sys/teacher", icon: <TeamOutlined /> },
        { name: "课程", key: "/sys/course", icon: <ContainerOutlined /> },
        { name: "场地", key: "/sys/field", icon: <ProfileOutlined /> },
        // { name: "工作考核", key: "/sys/kpi", icon: <FieldTimeOutlined />, role: "管理人员" },
        { name: "报表", key: "/sys/report", icon: <FieldTimeOutlined />, role: "管理人员" },
        { name: "设置", key: "/sys/setting", icon: <SettingOutlined /> },
    ],
    defaultTheme: {
        rowLightColor: "rgb(238, 238, 238)",
        rowDarkColor: "rgb(223, 225, 234)",
        rowHighDarkColor: "rgb(171, 174, 191)",
        editBackColor: "rgb(208, 210, 222)", //"#D0D2DE"
    },
    pagination: (total, page, pageSize, onPageChange) => {
        return {
            // style: { display: total > pageSize ? "flex" : "none", margin: 10 },
            style: { display: "flex", margin: 10 },
            pageSizeOptions: ["100", "200", "500", "1000", "2000"],
            total: total,
            pageSize: pageSize,
            current: page,
            showTotal: (total, range) => `显示第${range[0]}到第${range[1]}条记录，总共${total}条记录`,
            onChange: onPageChange,
            onShowSizeChange: onPageChange,
        }
    },
    provinceList: [
        "请选择",
        "北京市",
        "天津市",
        "上海市",
        "重庆市",
        "香港特别行政区",
        "澳门特别行政区",
        "安徽省",
        "福建省",
        "甘肃省",
        "广东省",
        "广西壮族自治区",
        "贵州省",
        "海南省",
        "河北省",
        "河南省",
        "黑龙江省",
        "湖北省",
        "湖南省",
        "吉林省",
        "江苏省",
        "江西省",
        "辽宁省",
        "内蒙古自治区",
        "宁夏回族自治区",
        "青海省",
        "山东省",
        "山西省",
        "陕西省",
        "四川省",
        "西藏自治区",
        "新疆维吾尔自治区",
        "云南省",
        "浙江省"
    ],
    UserRole: ["游客", "老师", "学生", "运维人员"],
    RoleLabel: {
        "XITONGGUANLIYUAN": "系统管理员",
        "YUNWEIRENYUAN": "运维人员",
        "LAOSHI": "老师",
        "XUESHENG": "学生",
        "YOUKE": "游客",
    },
    RoleCode: {
        "系统管理员": "XITONGGUANLIYUAN",
        "运维人员": "YUNWEIRENYUAN",
        "老师": "LAOSHI",
        "学生": "XUESHENG",
        "游客": "YOUKE",
    },
    Gender: [0, 1, 2],
    GenderList: ["未知", "男", "女",],
    setGenderLabel: (value) => {
        if (value === 0) {
            return "未知";
        } else if (value === 1) {
            return "男";
        } else if (value === 2) {
            return "女";
        } else {
            return "未知";
        }
    },
    applicationStatus: [null, 0, 1],
    applicationStatusLabel: ["待审核", "已驳回", "已通过"],
    courseStatus: [0, 1, 2, 3, 4, 5],
    courseStatusLabel: ["待上课", "上课中", "已上课", "已消课", "批准请假", "已取消"],
    leaveStatus: [0, 1, 2, 3],
    leaveStatusLabel: ["待批准", "已批准", "已驳回", "已过期"],
    reserveStatus: [0, 1, 2, 3, 4],
    reserveStatusLabel: ['约课待批准', '约课通过', '约课驳回', '约课取消', '约课过期'],

    classTypes: [   //课时类型
        { value: 1, label: "一对一" },
        { value: 2, label: "乐团课" },
        { value: 3, label: "小班课" },
    ],
}
